
import { Backdrop, Box, CircularProgress, Modal } from "@mui/material";
import Button from "@mui/material/Button";
import React, { useState, useRef, useEffect } from "react";
import AlertComponent from "../alert/alert";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  padding: "13px 16px",
};
const CreateNewVendorModal = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [createVendorOpen, setCreateVendorOpen] = useState(false);
  const [inviteQuesArr, setInviteQuesArr] = useState([]);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    setInviteQuesArr(props?.inviteQuesArr);
  }, [props?.inviteQuesArr]);

  const handleCloseLoader = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const onTextChange = (e, data, index) => {
    let { value } = e.target;
    if (data?.name === 'vendorName') {
      const cursorPosition = e.target.selectionStart;
      const startValue = inviteQuesArr[index].value;
      let value = e.target.value.toUpperCase();
      if (startValue !== value) {
        let inviteQuesArr3 = [...inviteQuesArr];
        inviteQuesArr3[index].value = value;
        setInviteQuesArr(inviteQuesArr3);
        requestAnimationFrame(() => {
          e.target.setSelectionRange(cursorPosition, cursorPosition);
        });
      }
    } else {
      let inviteQuesArr3 = [...inviteQuesArr];
      inviteQuesArr3[index].value = value;
      setInviteQuesArr(inviteQuesArr3);
    }
  };

  const onSelectChange = (e, data, index) => {
    let { name, value } = e.target;
    let inviteQuesArr3 = [...inviteQuesArr];
    inviteQuesArr3[index].value = value;
    setInviteQuesArr(inviteQuesArr3);
  };



  return (
    <>
      {/* Upload Modal */}
      <Modal
        open={props?.createVendorOpen}
        onClose={() => props?.inviteModalClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="lets_block_modal_listing">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="contactModalLabel">
                {/* Create Vendor Onboarding */}
                {props?.modalMsg}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                fdprocessedid="7f6r2r"
                onClick={() => props?.inviteModalClose()}
              ></button>
            </div>

            <div className="modal-body">
              <form id="vendorForm">
                <div className="row">
                  {inviteQuesArr.map((ele, i) => {
                    if (ele.type == "text") {
                      return (
                        <div className="col-sm-6 invite-col-6">
                          <label className="mb-1 text-dark">
                            {ele?.title}
                            {ele?.isRequired && (
                              <span className="required">*</span>
                            )}
                          </label>
                          <input
                            type="text"
                            id={ele?.name}
                            className="form-control form_h_modal"
                            placeholder={`Enter ${ele?.placeholder}`}
                            required={ele?.isRequired}
                            // fdprocessedid="9o7xi"
                            value={ele?.value}
                            onChange={(e) => onTextChange(e, ele, i)}
                            disabled={ele?.disabled}
                          />
                          {ele?.showAlert && (
                            <p className="error_message_form">
                              {ele?.alertMsg}
                            </p>
                          )}
                          {/* <div className="error-message" id="contactNameError">
                          {contactNameError}
                        </div> */}
                        </div>
                      );
                    }

                    if (ele.type == "select") {
                      return (
                        <div className="col-sm-12">
                          <label className="mb-1 text-dark">
                            {ele?.title}
                            {ele?.isRequired && (
                              <span className="required">*</span>
                            )}
                          </label>
                          <select
                            id={ele?.name}
                            className="form-select select_react_form_vendorlist"
                            aria-label="Default select example"
                            // fdprocessedid="7srmom"
                            value={ele?.value}
                            onChange={(e) => onSelectChange(e, ele, i)}
                            disabled={ele?.disabled}
                          >
                            {ele.options.map((opt, j) => (
                              <option value={opt?.value}> {opt?.label} </option>
                            ))}
                          </select>

                          {ele?.showAlert && (
                            <p className="error_message_form">
                              {ele?.alertMsg}
                            </p>
                          )}
                        </div>
                      );
                    }
                  })}
                </div>

                <div className="clear_btn_status">
                  <button
                    type="button"
                    className="btn clear_btn"
                    data-dismiss="modal"
                    fdprocessedid="frel3"
                    onClick={() => props?.inviteModalClose()}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-success save_next_btn"
                    onClick={() => props?.validateForm()}
                    fdprocessedid="q9hf9"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Box>
      </Modal>
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseLoader}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default CreateNewVendorModal;